import {
  Login,
  Home,
  CreateUser,
  Company,
  ListCompanies,
  Service,
  ListUsers,
  ListServices,
  CompanyServices,
  CreateProcess,
  BulkProcess,
  ListProcess,
  Process,
  Invoice,
  ListInvoices,
  CreateCompliance,
  ComplianceCompany,
  ListCompliance,
  ReportHours,
  ComplianceByUser,
  ComplianceManager,
  Indicators,
  EditInvoice,
  PendingToFinish,
  ServicesByAnalyst,
  CreateDocumentPlan,
  ListDocumentPlan,
  AssignDocumentPlan,
  DocumentManager,
  ReportDocuments,
  ViewDocumentDetails,
  Payment,
  ListPayments,
  EditPayment,
  Approvals,
  Tickets,
  Projects,
  MyTickets,
  DigitalReport,
  ListFormTemplates,
  FormTemplateEditor,
} from "../views";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/usuario",
    name: "Usuario",
    component: CreateUser,
    meta: {
      requiresAuth: true,
      blockedRoles: ["ACCOUNTING"],
    },
  },
  {
    path: "/buscar-usuarios",
    name: "Buscar Usuarios",
    component: ListUsers,
    meta: {
      requiresAuth: true,
      blockedRoles: ["ACCOUNTING"],
    },
  },
  {
    path: "/empresa",
    name: "Empresa",
    component: Company,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/servicios-empresa/:id",
    name: "Servicios por empresa",
    component: CompanyServices,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/buscar-empresas",
    name: "Buscar Empresas",
    component: ListCompanies,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/servicios",
    name: "Servicios",
    component: Service,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/lista-servicios",
    name: "Lista Servicios",
    component: ListServices,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/crear-proceso",
    name: "Crear Proceso",
    component: CreateProcess,
    meta: {
      requiresAuth: true,
      blockedRoles: ["ACCOUNTING", "CLIENT_APPROVER"],
    },
  },
  {
    path: "/carga-masiva-procesos",
    name: "Carga Masiva de Procesos",
    component: BulkProcess,
    meta: {
      requiresAuth: true,
      blockedRoles: ["ACCOUNTING"],
    },
  },
  {
    path: "/buscar-proceso",
    name: "Buscar Proceso",
    component: ListProcess,
    meta: {
      requiresAuth: true,
      blockedRoles: ["CLIENT_APPROVER"],
    },
  },
  {
    path: "/proceso/:id",
    name: "Proceso",
    component: Process,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/facturacion",
    name: "Facturación",
    component: Invoice,
    meta: {
      requiresAuth: true,
      whatsapp: false,
    },
  },
  {
    path: "/lista-facturacion",
    name: "Lista de facturación",
    component: ListInvoices,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/factura/:id",
    name: "Factura",
    component: EditInvoice,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cumplimiento",
    name: "Cumplimiento",
    component: CreateCompliance,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cumplimiento-empresa/:id",
    name: "Cumplimiento por empresa",
    component: ComplianceCompany,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/planes-cumplimiento",
    name: "Planes Cumplimiento",
    component: ListCompliance,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reportar-horas",
    name: "Reportar Horas",
    component: ReportHours,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cumplimiento-usuario",
    name: "Cumplimiento por usuario",
    component: ComplianceByUser,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/cumplimiento-admin",
    name: "Cumplimiento usuarios",
    component: ComplianceManager,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/indicadores",
    name: "Indicadores",
    component: Indicators,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/notificaciones/pendientes-finalizar",
    name: "PendingToFinish",
    component: PendingToFinish,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/notificaciones/servicios-analistas",
    name: "ServicesByAnalyst",
    component: ServicesByAnalyst,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/crear-plan-documental",
    name: "Crear plan documental",
    component: CreateDocumentPlan,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/planes-documentales",
    name: "Planes Documentales",
    component: ListDocumentPlan,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/documentos-empresa/:id",
    name: "Plan documentos empresa",
    component: AssignDocumentPlan,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/gestor-documental",
    name: "Gestor Documental",
    component: DocumentManager,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/reportar-documentos",
    name: "Reportar Documentos",
    component: ReportDocuments,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/documentos/:id",
    name: "ViewDocumentDetails",
    component: ViewDocumentDetails,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pagos",
    name: "Pagos",
    component: Payment,
    meta: {
      requiresAuth: true,
      whatsapp: false,
    },
  },
   {
    path: "/lista-pagos",
    name: "ListaPagos",
    component: ListPayments,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/pago/:id",
    name: "Pago",
    component: EditPayment,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/aprobaciones",
    name: "Aprobaciones",
    component: Approvals,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/tickets",
    name: "Tickets",
    component: Tickets,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/proyectos",
    name: "Projects",
    component: Projects,
    meta: {
      requiresAuth: true,
    },
  },
  {
    // XAN-143 — digital report (no menu entry and no button in the process yet, on purpose). Everybody with access
    // reads the whole report; who can write each section is enforced by the API.
    path: "/informe-digital/:processId?",
    name: "Informe Digital",
    component: DigitalReport,
    meta: {
      requiresAuth: true,
      allowedRoles: ["ADMIN", "RISK_SHIELD_ADMIN", "RISK_SHIELD", "ANALYST"],
    },
  },
  {
    path: "/mis-pendientes",
    name: "MyTickets",
    component: MyTickets,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/plantillas-formulario",
    name: "Lista Plantillas",
    component: ListFormTemplates,
    meta: {
      requiresAuth: true,
      allowedRoles: ["ADMIN", "RISK_SHIELD_ADMIN"],
    },
  },
  {
    path: "/plantilla-formulario/:id?",
    name: "Editor Plantilla",
    component: FormTemplateEditor,
    meta: {
      requiresAuth: true,
      allowedRoles: ["ADMIN", "RISK_SHIELD_ADMIN"],
    },
  },
];

export default routes;
